import Dashboard from "../views/overview/dashboard/dashboard-list-view";
import ChallengeSuggestion from "../views/overview/challenge-suggestion/challenge-suggestion-list-view";
import StoryReport from "../views/overview/story-report/story-report-list-view";
import Chat from "../views/overview/chat/chat-view";
import Admin from "../views/user/admin/admin-list-view";
import Parent from "../views/user/parent/parent-list-view";
import UserReport from "../views/user/user-report/user-report-list-view";
import Category from "../views/management/category/category-list-view";
import Challenge from "../views/management/challenge/challenge-list-view";
import ChallengeUserReport from "../views/management/challenge-user-report/challenge-user-report-list-view";
import Activity from "../views/management/activity/activity-list-view";
import Badge from "../views/management/badge/badge-list-view";
import Award from "../views/management/award/award-list-view";
import Step from "../views/management/step/step-list-view";
// import CreateStep from "../views/management/step/step-create-view";
// import EditStep from "../views/management/step/step-edit-view";
import { paths } from "./paths";
import Children from "views/user/children/children-list-view";
import StepForm from "views/management/step/step-form";
import StepFormUpdate from "views/management/step/step-form-update";

interface AppRoute {
  path: any;
  element: React.ReactElement;
}

export const routes = {
  // ----------------------------------------------------------------------
  //Auth Routes
  login: paths.auth.standard.login,

  // ----------------------------------------------------------------------
  // Overview Routes
  dashboard: paths.overview.dashboard.root,
  challengeSuggestions: paths.overview.challengeSuggestions.root,
  storyReports: paths.overview.storyReports.root,
  chat: paths.overview.chat.root,

  // ----------------------------------------------------------------------
  // User Routes
  childrens: paths.user.children.root,
  parents: paths.user.parent.root,
  admins: paths.user.admin.root,
  userReports: paths.user.userReports.root,

  // ----------------------------------------------------------------------
  // Management Routes
  categories: paths.management.category.root,
  challenges: paths.management.challenge.root,
  challengeUserReports: paths.management.challengeUserReports.root,
  badges: paths.management.badge.root,
  awards: paths.management.award.root,
  steps: paths.management.step.root,
  stepsCreate: paths.management.step.create,
  stepsEdit: (id: string) => paths.management.step.edit(id),
  activities: paths.management.activity.root,
};

export const routesComponents: AppRoute[] = [
  // Overview Routes to Components
  { path: routes.dashboard, element: <Dashboard /> },
  { path: routes.challengeSuggestions, element: <ChallengeSuggestion /> },
  { path: routes.storyReports, element: <StoryReport /> },

  // ----------------------------------------------------------------------
  // User Routes to Components
  { path: routes.chat, element: <Chat /> },
  { path: routes.childrens, element: <Children /> },
  { path: routes.parents, element: <Parent /> },
  { path: routes.admins, element: <Admin /> },
  { path: routes.userReports, element: <UserReport /> },

  // ----------------------------------------------------------------------
  // Management Routes to Components
  { path: routes.categories, element: <Category /> },
  { path: routes.challenges, element: <Challenge /> },
  { path: routes.challengeUserReports, element: <ChallengeUserReport /> },
  { path: routes.activities, element: <Activity /> },
  { path: routes.badges, element: <Badge /> },
  { path: routes.awards, element: <Award /> },
  { path: routes.steps, element: <Step /> },
  // { path: routes.stepsCreate, element: <CreateStep /> },
  { path: routes.stepsEdit(":id"), element: <StepFormUpdate /> },
];
